import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconSingleBed: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20 12.2V6C20 4.3 18.7 3 17 3H7C5.3 3 4 4.3 4 6V12.2C2.8 12.6 2 13.7 2 15V21C2 21.6 2.4 22 3 22C3.6 22 4 21.6 4 21V20H20V21C20 21.6 20.4 22 21 22C21.6 22 22 21.6 22 21V15C22 13.7 21.2 12.6 20 12.2ZM6 6C6 5.4 6.4 5 7 5H17C17.6 5 18 5.4 18 6V12H16V8C16 7.4 15.6 7 15 7H9C8.4 7 8 7.4 8 8V12H6V6ZM14 12H10V9H14V12ZM4 18V15C4 14.4 4.4 14 5 14H9H15H19C19.6 14 20 14.4 20 15V18H4Z',
    })
  )
}
